import {
    Component, Input, ViewChild, OnInit, ViewContainerRef,
    ComponentFactoryResolver
} from "@angular/core";
import { ActivatedRoute } from '@angular/router';
import { DomSanitizer } from '@angular/platform-browser';

import { SwalComponent, SwalPartialTargets } from '@toverux/ngx-sweetalert2';
import { Observable } from 'rxjs';

import { environment } from '../../../../../../environments/environment';

import { MonthlyCut, InvestorMonthlyCut } from '../../../../../_models';
import { isArray } from '../../../../../_models/Classes/class.helpers';
import { AlertService, AlertComponent } from '../../../../../shared/alert';
import { ModalComponent } from '../../../../../shared/modal';
import { UnitTableComponent } from '../../units/unit-table';
import { InvestorTableComponent } from '../../investor/investor-table';
import { MonthlyCutCustomService } from './../../../../../_services';



@Component({
    selector: 'app-monthly-cut-detail',
    templateUrl: './monthly-cut-detail.component.html'
})

export class MonthlyCutDetailComponent implements OnInit {
    investorsCount: number;
    inPool: number;
    monthlyCutId: number;
    unitShow = {
        floor: true,
        id_orange: true,
        investor: true,
        area_interior: true,
        area_common: true,
        area_terrace: true,
        total_area: true,
        area_terrace_half: true,
        pool_percentage: true,
        in_pool: true,
        net_income: true,
        detail: false
    }
    investorTexts = {
        label: "Propietario",
        notFound: "Propietario no encontrado",
        loading: "Cargando propietarios...",
        none: "Ningun propietario"
    };
    header = {
        icon: '',
        text: ''
    };
    currentUser: any = JSON.parse(localStorage.getItem('currentUser'));
    unitDataParams = `in_pool=1&include=investor,property`;
    isCurrentMonthNYear: boolean = false;
    unAuthorized: boolean = false;
    clickedRejected: boolean = false;
    canGenerateStatement: boolean = false;
    canDownloadDispersion: boolean = false;
    netIncome: number = 0;
    monthlyCut = this.data.make({});
    incomeResults = [];
    expenseResults = [];
    allState = false;
    statementData: any;
    attachment: File = <File>{};
    statementRequest$: Observable<any>;
    subject: string;
    bcc: string;
    message: string;
    @ViewChild('alert',
        { read: ViewContainerRef }) alertRef: ViewContainerRef;
    @ViewChild('questionSwal') private questionSwal: SwalComponent;
    @ViewChild('successSwal') private successSwal: SwalComponent;
    @ViewChild('startSwal') private startSwal: SwalComponent;
    @ViewChild('errorSwal') private errorSwal: SwalComponent;
    @ViewChild('investorSelection') private investorsModal: ModalComponent;
    @ViewChild('statementModal') private statementModal: ModalComponent;
    @ViewChild('dispersionSwal') private dispersionSwal: SwalComponent;
    action: Function;
    investors: any[] = []; // string | number[]
    investorsSelect: any[] = []; // string | number[]
    constructor(private route: ActivatedRoute, private data: MonthlyCut,
        private investorData: InvestorMonthlyCut,
        private _cfr: ComponentFactoryResolver,
        private _alertService: AlertService,
        private sanitizer: DomSanitizer,
        private _monthlyCut: MonthlyCutCustomService
    ) { }
    ngOnInit() {
        this.monthlyCutId = this.route.snapshot.params['id'];
        this.clickedRejected = false;
        this.getMonthlyCut().subscribe(monthlyCut => {
            this.monthlyCut = monthlyCut;
            this.netIncome = monthlyCut.net_income;
            this.header.text = `Corte ${monthlyCut.monthName} ${monthlyCut.year}`;
            this.data.getMonthlyInvoiceDay().subscribe(day => {
                let now = new Date();
                if (this.hasAnyRole(this.currentUser, [4]) && !this.unAuthorized
                    && this.isCurrentMonthNYear && (now.getDate() < day)) {
                    this.showAlert(`Tienes hasta el ${day} para subir las facturas de los 
                        propietarios para incluirlos en el archivo de dispersion del mes`, 'info');
                }
            });
        });
        this.data.getIncomesResults(this.monthlyCutId).subscribe(data => { this.incomeResults = data });
        this.data.getExpensesResults(this.monthlyCutId).subscribe(data => { this.expenseResults = data });
        /*this.validation_subject();*/
        this.validationButtonSend();
        this.validationButtonGenerate();
    }
    getMonthlyCut() {
        return this.data.get(this.monthlyCutId).map(monthlyCut => {
            this.canGenerateStatement =
                monthlyCut.authorization &&
                monthlyCut.authorization.state == 'authorized';
            this.canDownloadDispersion = this.canGenerateStatement;
            let now = new Date();
            this.isCurrentMonthNYear = monthlyCut.year == now.getFullYear() &&
                monthlyCut.month == (now.getMonth() + 1);
            this.unAuthorized = monthlyCut.unAuthorized(this.currentUser);
            this.investorsCount = monthlyCut.investor_count;
            return monthlyCut;
        });
    }
    showAlert(message, type) {
        this.alertRef.clear();
        let factory = this._cfr.resolveComponentFactory(AlertComponent);
        let ref = this.alertRef.createComponent(factory);
        ref.changeDetectorRef.detectChanges();
        this._alertService[type](message);
    }
    askForAuth() {
        this.data.askForAuth(this.currentUser.user.id, this.data.instance.id).subscribe(response => {
            this.getMonthlyCut().subscribe();
            if (response['status'] == 'success') {
                this.successSwal.text = response['message'];
                this.successSwal.show();
            } else {
                this.errorSwal.text = 'Error al procesar solicitud';
                this.errorSwal.show();
            }

        }, error => {
            this.errorSwal.text = error.error.message;
            this.errorSwal.show();
        });
    }
    reject() {
        this.clickedRejected = true;
        this.data.reject(this.currentUser.user.id, this.data.instance.id).subscribe(response => {
            this.getMonthlyCut().subscribe();
        });
    }
    auth() {
        this.data.authorize(this.currentUser.user.id, this.data.instance.id).subscribe(response => {
            this.getMonthlyCut().subscribe();
            if (response['status'] == 'success') {
                this.successSwal.text = response['message'];
                this.successSwal.show();
            } else {
                this.errorSwal.text = 'Error al procesar solicitud';
                this.errorSwal.show();
            }

        }, error => {
            this.errorSwal.text = error.error.message;
            this.errorSwal.show();
        });
    }
    generateStatement() {
        let form = new FormData();
        console.log(this.investors);
        form.set('investors', this.allState ? 'all' : this.investors.join(','));
        this.startSwal.show();

        this._monthlyCut.generateStatement(this.monthlyCutId, form).subscribe(response => {
            if (response.message) {
                this.successSwal.text = response.message;
                this.successSwal.show();
                this.getInvestorData();
            } else {
                this.errorSwal.show();
            }
            setTimeout(() => {
                window.location.reload();
            }, 2000);
        }, err => {
            console.error(err);
            this.errorSwal.text = err;
            this.errorSwal.show();
            this.investors = []
        }, () => {

        });
    }
    sendStatement() {
        let form = new FormData();
        console.log(this.investors);
        form.set('investors', this.allState ? 'all' : this.investors.join(','));
        form.set('subject', this.subject);
        form.set('bcc', this.bcc);
        form.set('message', this.message);
        form.set('attachment', (this.attachment.name) ? this.attachment : null);
        this.startSwal.show();

        this._monthlyCut.sendStatement(this.monthlyCutId, form).subscribe(response => {
            if (response.message) {
                this.successSwal.text = response.message;
                this.successSwal.show();
                this.getInvestorData();
            } else {
                this.errorSwal.show();
            }
            setTimeout(() => {
                window.location.reload();
            }, 2000);
        }, err => {
            console.error(err);
            this.errorSwal.text = err;
            this.errorSwal.show();
            this.investors = []
        }, () => {

        });

    }

    validInvestors() {
        return this.allState || isArray(this.investors) && this.investors.length;
    }
    onAttachmentFileChange($event) {
        this.attachment = $event.target.files[0];

    }

    downloadDispersion(type) {
        let dispersion_type = type;
        this._monthlyCut.downloadDispersion(this.monthlyCutId, dispersion_type).subscribe(response => {
            window.location.href = response.url;
        }, err => {
            console.error(err);
            this.errorSwal.text = err;
            this.errorSwal.show();
        }, () => {

        });
    }
    showQuestionText(foo: Function) {
        this.action = foo;
        if (this.action == this.askForAuth) {
            this.questionSwal.text = '¿Desea solicitar autorización para este corte?';
            this.questionSwal.confirmButtonText = 'Solicitar';
        }
        else if (this.action == this.reject) {
            this.questionSwal.text = '¿Desea rechazar la autorización de este corte?';
            this.questionSwal.confirmButtonText = 'Rechazar';
        }
        else if (this.action == this.auth) {
            this.questionSwal.text = '¿Desea aprobar la autorización de este corte?';
            this.questionSwal.confirmButtonText = 'Autorizar';
        }
        else if (this.action == this.generateStatement) {
            this.questionSwal.text = '¿Desea generar el estado de cuenta para este corte?';
            this.startSwal.text = 'Se ha iniciado la generación de estados de cuenta, se le notificará cuando el proceso haya terminado';
            this.questionSwal.confirmButtonText = 'Generar';
        }
        else if (this.action == this.sendStatement) {
            this.questionSwal.text = '¿Desea enviar el estado de cuenta para este corte?';
            this.questionSwal.confirmButtonText = 'Enviar';
            this.startSwal.text = 'Se ha iniciado el envio de correos, se le notificará cuando el proceso haya terminado';
            this.startSwal.confirmButtonText = 'Entendido';
        }
        else {
            this.questionSwal.text = '';
        }
        this.questionSwal.show();
    }
    setAll(e) {
        var state = e.target.checked;
        this.allState = state;
        let collection = this.investorData.collection;
        if (collection) {
            this.investorsSelect = [];
            collection.forEach(item => {
                (item.investor as any).check = this.allState;
            });
        }
        if (!this.allState) {
            this.investorsSelect = [];
            this.investors = collection.filter((item) => {
                return (item.investor as any).check;
            }).map((item) => {
                return item.id;
            });
        }
    }
    setOne(investor, state) {
        investor.check = state;
        this.investors = this.investorData.collection.filter((item) => {
            return (item.investor as any).check;
        }).map((item) => {
            return item.investor.id;
        });
        this.generateStatement();
    }
    showStatement(url) {
        let full_url = `${environment.fileEndpoint}/${url}`;
        this.statementData = this.sanitizer.bypassSecurityTrustResourceUrl(full_url);
        this.statementModal.show();
    }
    tabChanged(tab) {
        switch (tab.id) {
            case 'propietarios':
            case 'edo':
                this.getInvestorData();
                break;
        }
    }
    getInvestorData() {
        this.investorData.getAll(this.monthlyCutId, 'include=investor,statement,invoice').subscribe();
    }
    hasAnyRole(user, rolesIds): boolean {
        let result = false;
        user.role.forEach(role => {
            if (rolesIds.includes(role.id)) {
                result = true;
            } else {
                result = false;
            }
        });
        return result;
    }
    selectInvestors(id, e) {
        this.allState = false;
        var status = e.target.checked;
        if (status) {
            if (!this.in_array(id, this.investorsSelect)) {
                this.investorsSelect.push(id);
            } else {
                let index = this.investorsSelect.indexOf(id);
                this.investorsSelect.splice(index, (index == 0 ? 1 : index));
            }
        } else {
            let index = this.investorsSelect.indexOf(id);
            this.investorsSelect.splice(index, (index == 0 ? 1 : index));
        }
        this.investors = this.investorsSelect;
        console.log(this.investors);
    }
    in_array(valor, investors, prop = null) {
        let array = [];
        array = investors;
        let value = valor;
        for (let i = 0; i < array.length; i++) {
            if (value == ((prop) ? array[i][prop] : array[i])) {
                return true;
            }
        }
        return false;
    }
    //puede utilizarse en caso de validación para mínimo de caracteres
    /*validation_subject() {
        let value = String((this.subject == undefined) ? ' ' :  this.subject);
        console.log(value);
        let input = document.getElementById("subject");
        if(value.length < 4) {
            input.classList.remove("form-control-danger");
            return true;
        } else {
            input.classList.add("form-control-danger");
            return false;
        }
    }*/
    validationButtonSend() {
        let investors = (this.investors == undefined) ? [] : this.investors;
        let attachment = !!(this.attachment.size > 0);

        return attachment && investors.length > 0 || this.allState && attachment;
    }

    validationButtonGenerate() {
        let investors = (this.investors == undefined) ? [] : this.investors;

        return investors.length > 0 || this.allState;
    }
    showDispersion() {
        this.dispersionSwal.show();
    }
}



// WEBPACK FOOTER //
// /Users/cmedina/Code/motto_frontend/src/app/theme/pages/aside-left-display-disabled/monthly-cut/monthly-cut-detail/monthly-cut-detail.component.ts